import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { haptic } from '../telegram';

const NAV_ITEMS = [
  { to: '/',         label: 'Дашборд',   icon: '⊞' },
  { to: '/agents',   label: 'Агенты',    icon: '▦' },
  { to: '/tasks',    label: 'Задачи',    icon: '✓' },
  { to: '/settings', label: 'Настройки', icon: '⚙️' },
];

const wrapSt: React.CSSProperties  = { display: 'flex', flexDirection: 'column', minHeight: '100vh' };
const mainSt: React.CSSProperties  = { flex: 1, overflowY: 'auto', paddingBottom: 64 };
const navBarSt: React.CSSProperties = {
  position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 50,
  display: 'flex',
  background: 'var(--tg-theme-secondary-bg-color)',
  borderTop: '1px solid rgba(255,255,255,0.08)',
};
const iconSt: React.CSSProperties = { fontSize: 20, lineHeight: 1, marginBottom: 2 };

export default function Layout() {
  return (
    <div style={wrapSt}>
      <main style={mainSt}>
        <Outlet />
      </main>
      <nav style={navBarSt}>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            onClick={() => haptic('light')}
            style={({ isActive }) => ({
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center',
              padding: '6px 0', fontSize: 11, textDecoration: 'none',
              color: isActive
                ? 'var(--tg-theme-button-color)'
                : 'var(--tg-theme-hint-color)',
              transition: 'color 0.15s',
            })}
          >
            <span style={iconSt}>{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
